import { CreateProtocolService } from "../api/services/protocolService"
import { ProtocolService } from "../declarations/protocolService"
import { toast } from "react-toastify";

export function useProtocolService(){


    const protocolService = async (payload: ProtocolService) => {
    
        try {
            const response = await CreateProtocolService(payload);
            console.log('resp', response);
            const { message, status, errors } = response;
    
            if (status === 201) {
                message && toast["success"](message);
            } else {
                message && toast["error"](message);
            }
            return response
        } catch (error) {
            console.error("Error in insuranceProvider:", error);
        }

        
    };


    return {
        protocolService
    }
    
 
}